import * as React from 'react';
import { UploadedVideoAttachment } from '../../../typedefs/store';
import styled from 'styled-components';

interface Props {
    attachment: UploadedVideoAttachment;
}

const UploadedVideoAttachment: React.SFC<Props> = ({ attachment }) => {
    return (
        <Wrapper className="conversations-attachment conversations-attachment-video-uploaded">
            <video poster={attachment.thumbUrl} src={attachment.fileUrl} controls={true}>
                Your browser does not support the video tag.
            </video>
            <Title>
                {attachment.year} {attachment.make} {attachment.model}
            </Title>
        </Wrapper>
    );
};

export default UploadedVideoAttachment;

const Wrapper = styled.div`
    video {
        max-width: 100%;
    }
`;

const Title = styled.div`margin-top: 5px;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/Attachments/UploadedVideoAttachment.tsx